import { render, staticRenderFns } from "./saveFielf.vue?vue&type=template&id=7688a48c&scoped=true&"
import script from "./saveFielf.vue?vue&type=script&lang=js&"
export * from "./saveFielf.vue?vue&type=script&lang=js&"
import style0 from "./saveFielf.vue?vue&type=style&index=0&id=7688a48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7688a48c",
  null
  
)

export default component.exports